var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "38px",
    viewBox: "0 0 46 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons8-error")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "alert-icon-cutout",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 38
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 46,
    height: 38,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3243243,31.043625 C20.3243243,30.7241875 20.384027,30.4320625 20.505973,30.15775 C20.6253784,29.887 20.7968649,29.651875 21.0178919,29.45475 C21.2351081,29.25525 21.5031351,29.0996875 21.8105405,28.9880625 C22.1204865,28.8788125 22.4685405,28.820625 22.8572432,28.820625 C23.2459459,28.820625 23.5965405,28.8788125 23.909027,28.9880625 C24.2265946,29.0996875 24.4946216,29.25525 24.7118378,29.45475 C24.9341351,29.651875 25.1056216,29.887 25.2237568,30.15775 C25.3457027,30.4320625 25.4054054,30.7241875 25.4054054,31.043625 C25.4054054,31.36425 25.3457027,31.656375 25.2237568,31.922375 C25.1043514,32.1895625 24.9328649,32.4199375 24.7118378,32.620625 C24.4946216,32.81775 24.2265946,32.972125 23.909027,33.086125 C23.5965405,33.195375 23.2459459,33.25 22.8572432,33.25 C22.4672703,33.25 22.1204865,33.195375 21.8105405,33.0849375 C21.5031351,32.9709375 21.2351081,32.8165625 21.0178919,32.6194375 C20.7955946,32.41875 20.6241081,32.188375 20.505973,31.9211875 C20.384027,31.6551875 20.3243243,31.3630625 20.3243243,31.043625 Z M24.7448649,26.125 L20.9683514,26.125 L20.4335676,11.875 L25.2783784,11.875 L24.7448649,26.125 Z",
    id: "Cutout",
    fill: "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Risk-assessment---Site-surveying-(shared-no-permissions)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-245.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-error",
    transform: "translate(245.000000, 235.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1891892,38 L2.54054054,38 C1.62975676,38 0.791378378,37.5451875 0.337891892,36.80775 C-0.114324324,36.0703125 -0.111783784,35.1630625 0.346783784,34.428 L20.6711081,1.178 C21.1258649,0.448875 21.9617027,0 22.8648649,0 C23.768027,0 24.6038649,0.448875 25.0598919,1.178 L45.3842162,34.428 C45.8427838,35.1630625 45.8453243,36.0703125 45.3931081,36.80775 C44.9408919,37.5451875 44.0987027,38 43.1891892,38 Z",
    id: "Shape",
    fill: "currentColor",
    mask: "url(#alert-icon-cutout)"
  })))));
};
export default SvgAlertIcon;